// import React, { useState, useEffect, useContext } from "react";
// import axios from "axios";
// import { DayPicker } from "react-day-picker";
// import "react-day-picker/dist/style.css";
// import { format, parseISO, isSameDay } from "date-fns";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import Select from "react-select";

// const daysOfWeek = [
//   "SUNDAY",
//   "MONDAY",
//   "TUESDAY",
//   "WEDNESDAY",
//   "THURSDAY",
//   "FRIDAY",
//   "SATURDAY",
// ];
// const weekNumbers = [1, 2, 3, 4, 5];

// const WorkingPolicy = () => {
//   const { user } = useContext(AuthContext);
//   const [policy, setPolicy] = useState({
//     companyId: user?.accountType === "COMPANY" ? user.id : user?.companyId,
//     userId: user?.id ? [user.id] : [],
//     workingDays: [],
//     dailyWorkingHours: {},
//     publicHolidays: [],
//     enableWeeklyShiftRotation: false,
//     workingWeeksOfMonth: [],
//     weeklyRotationalDays: [],
//     isCustomForUser: false,
//   });
//   const [loading, setLoading] = useState(true);
//   const [users, setUsers] = useState([]);
//   const [activeTab, setActiveTab] = useState("workingDays");
//   const [selectedHolidays, setSelectedHolidays] = useState([]);

//   const companyId = user?.accountType === "COMPANY" ? user.id : user?.companyId;

//   // Fetch users
//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;
//       const url =
//         user?.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const data = await response.json();
//         setUsers(
//           data.map((user) => ({
//             value: user.id,
//             label: `${user.fname} ${user.lname}`,
//           }))
//         );
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }
//     fetchUsers();
//   }, [user]);

//   // Fetch policy data
//   useEffect(() => {
//     const fetchPolicy = async () => {
//       try {
//         setLoading(true);
//         let url;
//         if (user?.accountType === "COMPANY") {
//           url = `${API_URL}/api/working-policy/${companyId}`;
//         } else {
//           url = `${API_URL}/api/working-policy/${companyId}/${user?.id}`;
//         }

//         const response = await axios.get(url, {
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });

//         const policyData = response.data;

//         // Map the response data to match your state structure
//         const mappedData = {
//           id: policyData.id,
//           companyId: policyData.companyId,
//           userId: Array.isArray(policyData.userId)
//             ? policyData.userId
//             : [policyData.userId],
//           workingDays: Object.keys(policyData.dailyWorkingHours || {}), // Extract working days from dailyWorkingHours
//           dailyWorkingHours: policyData.dailyWorkingHours || {},
//           publicHolidays: policyData.publicHolidays || [],
//           enableWeeklyShiftRotation:
//             policyData.enableWeeklyShiftRotation || false,
//           workingWeeksOfMonth: policyData.workingWeeksOfMonth || [],
//           weeklyRotationalDays: policyData.weeklyRotationalDays || [],
//           isCustomForUser: policyData.customForUser || false,
//         };

//         setPolicy(mappedData);
//         setSelectedHolidays(
//           mappedData.publicHolidays?.map((date) => {
//             try {
//               return parseISO(date);
//             } catch (e) {
//               console.error("Invalid date:", date);
//               return new Date(); // fallback to current date if parsing fails
//             }
//           }) || []
//         );
//         setLoading(false);
//       } catch (error) {
//         console.error("Error fetching policy:", error);
//         setLoading(false);
//       }
//     };

//     fetchPolicy();
//   }, [companyId, user]);

//   // Handle day selection for working days
//   const handleWorkingDayToggle = (day) => {
//     setPolicy((prev) => {
//       const newWorkingDays = prev.workingDays.includes(day)
//         ? prev.workingDays.filter((d) => d !== day)
//         : [...prev.workingDays, day];

//       // Initialize working hours for newly added days
//       const newDailyWorkingHours = { ...prev.dailyWorkingHours };
//       if (!prev.workingDays.includes(day)) {
//         newDailyWorkingHours[day] = { startTime: "09:00", endTime: "18:00" };
//       } else if (!newWorkingDays.includes(day)) {
//         delete newDailyWorkingHours[day];
//       }

//       return {
//         ...prev,
//         workingDays: newWorkingDays,
//         dailyWorkingHours: newDailyWorkingHours,
//       };
//     });
//   };

//   // Handle time change for working hours
//   const handleTimeChange = (day, field, value) => {
//     setPolicy((prev) => ({
//       ...prev,
//       dailyWorkingHours: {
//         ...prev.dailyWorkingHours,
//         [day]: {
//           ...prev.dailyWorkingHours[day],
//           [field]: value,
//         },
//       },
//     }));
//   };

//   // Handle holiday selection
//   const handleHolidaySelect = (date) => {
//     if (!date) return; // Guard against undefined/null dates

//     setSelectedHolidays((prev) => {
//       // Check if the date is already selected
//       const isSelected = prev.some((d) => d && isSameDay(d, date));

//       if (isSelected) {
//         // Remove the date if it's already selected
//         return prev.filter((d) => d && !isSameDay(d, date));
//       } else {
//         // Add the new date if it's not already selected
//         return [...prev, date];
//       }
//     });
//   };

//   // Handle week number toggle for shift rotation
//   const handleWeekNumberToggle = (week) => {
//     setPolicy((prev) => ({
//       ...prev,
//       workingWeeksOfMonth: prev.workingWeeksOfMonth.includes(week)
//         ? prev.workingWeeksOfMonth.filter((w) => w !== week)
//         : [...prev.workingWeeksOfMonth, week],
//     }));
//   };

//   // Handle rotational day toggle
//   const handleRotationalDayToggle = (day) => {
//     setPolicy((prev) => ({
//       ...prev,
//       weeklyRotationalDays: prev.weeklyRotationalDays.includes(day)
//         ? prev.weeklyRotationalDays.filter((d) => d !== day)
//         : [...prev.weeklyRotationalDays, day],
//     }));
//   };

//   // Handle custom for user toggle
//   const handleCustomForUserToggle = (e) => {
//     const isChecked = e.target.checked;
//     setPolicy((prev) => ({
//       ...prev,
//       isCustomForUser: isChecked,
//       userId: isChecked ? [] : user?.id ? [user.id] : [],
//     }));
//   };

//   const handleUserSelect = (selectedOptions) => {
//     const selectedUserId = selectedOptions
//       ? selectedOptions.map((option) => option.value)
//       : [];
//     setPolicy((prev) => ({
//       ...prev,
//       userId: Array.isArray(selectedUserId) ? selectedUserId : [],
//     }));
//   };

//   // Save policy
//   const savePolicy = async () => {
//     try {
//       setLoading(true);
//       // Create payload without workingDays field
//       const { workingDays, ...payloadWithoutWorkingDays } = policy;

//       // Prepare the base payload
//       const payload = {
//         ...payloadWithoutWorkingDays,
//         publicHolidays: selectedHolidays.map((date) =>
//           format(date, "yyyy-MM-dd")
//         ),
//       };

//       // If it's not custom for user, remove userId from payload
//       if (!payload.isCustomForUser) {
//         delete payload.userId;
//       }

//       // Check if we're updating an existing policy (has id)
//       const isUpdate = payloadWithoutWorkingDays.id !== undefined;

//       // Send the appropriate payload
//       const response = await axios.post(
//         `${API_URL}/api/working-policy/set`,
//         payload,
//         {
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       // Update our local state with the response data
//       if (response.data?.id) {
//         const responseData = response.data;
//         setPolicy((prev) => ({
//           ...prev,
//           id: responseData.id,
//           companyId: responseData.companyId,
//           userId: Array.isArray(responseData.userId)
//             ? responseData.userId
//             : [responseData.userId],
//           dailyWorkingHours: responseData.dailyWorkingHours || {},
//           publicHolidays: responseData.publicHolidays || [],
//           enableWeeklyShiftRotation:
//             responseData.enableWeeklyShiftRotation || false,
//           workingWeeksOfMonth: responseData.workingWeeksOfMonth || [],
//           weeklyRotationalDays: responseData.weeklyRotationalDays || [],
//           isCustomForUser: responseData.customForUser || false,
//         }));
//         setSelectedHolidays(
//           responseData.publicHolidays?.map((date) => parseISO(date)) || []
//         );
//       }
      
//       toast.success(`Policy ${isUpdate ? "updated" : "saved"} successfully!`);
//     } catch (error) {
//       const isUpdate = policy.id !== undefined;
//       console.error("Error saving policy:", error);
//       toast.error(`Failed to ${isUpdate ? "update" : "save"} policy`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Apply to all users
//   const applyToAllUsers = async () => {
//     if (
//       window.confirm("Are you sure you want to apply this policy to all users?")
//     ) {
//       try {
//         setLoading(true);
//         // Create payload without workingDays field
//         const { workingDays, ...payloadWithoutWorkingDays } = policy;
//         const payload = {
//           ...payloadWithoutWorkingDays,
//           userId: null,
//           isCustomForUser: false,
//           publicHolidays: selectedHolidays.map((date) =>
//             format(date, "yyyy-MM-dd")
//           ),
//         };

//         await axios.post(`${API_URL}/api/working-policy/set`, payload, {
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });
//         toast.success("Policy applied to all users successfully!");
//       } catch (error) {
//         console.error("Error applying policy:", error);
//         toast.error("Failed to apply policy to all users");
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-100 p-4 md:p-8 shadow-lg dark:bg-gray-900 dark:text-white">

//       <div className="max-w-6xl mx-auto ">
//         <div className="bg-white rounded-xl shadow-md overflow-hidden dark:bg-gray-800 dark:text-white">
//           {/* Header */}
//           <div className="bg-gradient-to-r from-blue-600 to-blue-800 p-6 text-white">
//             <h1 className="text-2xl md:text-3xl font-bold">
//               {user?.id ? "User Working Policy" : "Company Working Policy"}
//             </h1>
//             <p className="text-blue-100 mt-2">
//               Configure working days, hours, holidays, and shift rotations
//             </p>
//           </div>

//           {/* Custom for user checkbox and user selection */}
//           {/* <div className="p-6 border-b">
//             <div className="flex flex-col space-y-4">
//               <div className="flex items-center">
//                 <input
//                   type="checkbox"
//                   id="isCustomForUser"
//                   className="h-4 w-4 text-blue-600 rounded"
//                   checked={policy.isCustomForUser || false}
//                   onChange={handleCustomForUserToggle}
//                 />
//                 <label
//                   htmlFor="isCustomForUser"
//                   className="ml-2 font-medium text-gray-700 dark:text-white"
//                 >
//                   Create custom policy for specific users
//                 </label>
//               </div>

//               {policy.isCustomForUser && (
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Select Users
//                   </label>
//                   <Select
//                     isMulti
//                     options={users}
//                     className="basic-multi-select"
//                     classNamePrefix="select"
//                     value={users.filter((user) =>
//                       (policy.userId || []).includes(user.value)
//                     )}
//                     onChange={handleUserSelect}
//                   />
//                 </div>
//               )}
//             </div>
//           </div> */}

//           {/* Tabs */}
//           <div className="border-b border-gray-200">
//             <nav className="flex overflow-x-auto">
//               <button
//                 className={`px-6 py-4 font-medium text-sm ${
//                   activeTab === "workingDays"
//                     ? "text-blue-600 border-b-2 border-blue-600"
//                     : "text-gray-500 hover:text-gray-700"
//                 }`}
//                 onClick={() => setActiveTab("workingDays")}
//               >
//                 Working Days & Hours
//               </button>
//               <button
//                 className={`px-6 py-4 font-medium text-sm ${
//                   activeTab === "holidays"
//                     ? "text-blue-600 border-b-2 border-blue-600"
//                     : "text-gray-500 hover:text-gray-700"
//                 }`}
//                 onClick={() => setActiveTab("holidays")}
//               >
//                 Public Holidays
//               </button>
//               <button
//                 className={`px-6 py-4 font-medium text-sm ${
//                   activeTab === "shiftRotation"
//                     ? "text-blue-600 border-b-2 border-blue-600"
//                     : "text-gray-500 hover:text-gray-700"
//                 }`}
//                 onClick={() => setActiveTab("shiftRotation")}
//               >
//                 Shift Rotation
//               </button>
//             </nav>
//           </div>

//           {/* Tab Content */}
//           <div className="p-6">
//             {/* Working Days & Hours Tab */}
//             {activeTab === "workingDays" && (
//               <div className="space-y-6">
//                 <div>
//                   <h2 className="text-lg font-medium text-gray-900 mb-4 dark:text-white">
//                     Working Days
//                   </h2>
//                   <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-7 gap-2">
//                     {daysOfWeek.map((day) => (
//                       <button
//                         key={day}
//                         className={`p-3 rounded-md text-center ${
//                           (policy.workingDays || []).includes(day)
//                             ? "bg-blue-100 text-blue-800 font-medium"
//                             : "bg-gray-100 text-gray-700"
//                         }`}
//                         onClick={() => handleWorkingDayToggle(day)}
//                       >
//                         {day.slice(0, 3)}
//                       </button>
//                     ))}
//                   </div>
//                 </div>

//                 <div>
//                   <h2 className="text-lg font-medium text-gray-900 mb-4 dark:text-white">
//                     Daily Working Hours
//                   </h2>
//                   <div className="space-y-4">
//                     {(policy.workingDays || []).map((day) => (
//                       <div
//                         key={day}
//                         className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center"
//                       >
//                         <div className="font-medium">{day}</div>
//                         <div className="flex items-center gap-2">
//                           <input
//                             type="time"
//                             className="p-2 border rounded-md dark:bg-gray-700"
//                             value={
//                               policy.dailyWorkingHours[
//                                 day
//                               ]?.startTime?.substring(0, 5) || "09:00"
//                             }
//                             onChange={(e) =>
//                               handleTimeChange(day, "startTime", e.target.value)
//                             }
//                           />
//                           <span>to</span>
//                           <input
//                             type="time"
//                             className="p-2 border rounded-md dark:bg-gray-700"
//                             value={
//                               policy.dailyWorkingHours[day]?.endTime?.substring(
//                                 0,
//                                 5
//                               ) || "18:00"
//                             }
//                             onChange={(e) =>
//                               handleTimeChange(day, "endTime", e.target.value)
//                             }
//                           />
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Holidays Tab */}
//             {activeTab === "holidays" && (
//               <div className="space-y-6">
//                 <div>
//                   <h2 className="text-lg font-medium text-gray-900 mb-4 dark:text-white">
//                     Public Holidays
//                   </h2>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <div>
//                       <DayPicker
//                         mode="multiple"
//                         selected={selectedHolidays}
//                         onSelect={setSelectedHolidays}
//                         modifiers={{
//                           selected: selectedHolidays,
//                         }}
//                         modifiersStyles={{
//                           selected: {
//                             backgroundColor: "#3b82f6",
//                             color: "white",
//                           },
//                         }}
//                       />
//                     </div>
//                     <div>
//                       <h3 className="text-md font-medium text-gray-900 mb-2 dark:text-white">
//                         Selected Holidays
//                       </h3>
//                       {selectedHolidays.length > 0 ? (
//                         <ul className="border rounded-md divide-y">
//                           {selectedHolidays.map((date, index) => {
//                             try {
//                               return (
//                                 <li
//                                   key={index}
//                                   className="p-3 flex justify-between items-center"
//                                 >
//                                   <span>
//                                     {date
//                                       ? format(date, "MMMM d, yyyy")
//                                       : "Invalid date"}
//                                   </span>
//                                   <button
//                                     className="text-red-500 hover:text-red-700"
//                                     onClick={() => handleHolidaySelect(date)}
//                                   >
//                                     Remove
//                                   </button>
//                                 </li>
//                               );
//                             } catch (e) {
//                               console.error("Error formatting date:", date, e);
//                               return null; // or render some fallback UI
//                             }
//                           })}
//                         </ul>
//                       ) : (
//                         <p className="text-gray-500 italic">
//                           No holidays selected
//                         </p>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Shift Rotation Tab */}
//             {activeTab === "shiftRotation" && (
//               <div className="space-y-6">
//                 <div className="flex items-center">
//                   <input
//                     type="checkbox"
//                     id="enableShiftRotation"
//                     className="h-4 w-4 text-blue-600 rounded"
//                     checked={policy.enableWeeklyShiftRotation || false}
//                     onChange={(e) =>
//                       setPolicy((prev) => ({
//                         ...prev,
//                         enableWeeklyShiftRotation: e.target.checked,
//                       }))
//                     }
//                   />
//                   <label
//                     htmlFor="enableShiftRotation"
//                     className="ml-2 font-medium text-gray-900 dark:text-white"
//                   >
//                     Enable Weekly Shift Rotation
//                   </label>
//                 </div>

//                 {policy.enableWeeklyShiftRotation && (
//                   <>
//                     <div>
//                       <h2 className="text-lg font-medium text-gray-900 mb-4 dark:text-white">
//                         Working Weeks of Month
//                       </h2>
//                       <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
//                         {weekNumbers.map((week) => (
//                           <button
//                             key={week}
//                             className={`p-3 rounded-md text-center ${
//                               (policy.workingWeeksOfMonth || []).includes(week)
//                                 ? "bg-blue-100 text-blue-800 font-medium"
//                                 : "bg-gray-100 text-gray-700"
//                             }`}
//                             onClick={() => handleWeekNumberToggle(week)}
//                           >
//                             Week {week}
//                           </button>
//                         ))}
//                       </div>
//                     </div>

//                     <div>
//                       <h2 className="text-lg font-medium text-gray-900 mb-4 dark:text-white">
//                         Weekly Rotational Days
//                       </h2>
//                       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-7 gap-2">
//                         {daysOfWeek.map((day) => (
//                           <button
//                             key={day}
//                             className={`p-3 rounded-md text-center ${
//                               (policy.weeklyRotationalDays || []).includes(day)
//                                 ? "bg-blue-100 text-blue-800 font-medium"
//                                 : "bg-gray-100 text-gray-700"
//                             }`}
//                             onClick={() => handleRotationalDayToggle(day)}
//                           >
//                             {day.slice(0, 3)}
//                           </button>
//                         ))}
//                       </div>
//                     </div>
//                   </>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Footer with action buttons */}
//           <div className="bg-gray-50 px-6 py-4 flex flex-col sm:flex-row justify-end gap-3 dark:bg-gray-800">
//             {!user && (
//               <button
//                 className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
//                 onClick={applyToAllUsers}
//                 disabled={loading}
//               >
//                 Apply to All Users
//               </button>
//             )}
//             <button
//               className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//               onClick={savePolicy}
//               disabled={loading}
//             >
//               {loading
//                 ? "Saving..."
//                 : policy.id
//                 ? "Update Policy"
//                 : "Save Policy"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WorkingPolicy;







import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format, parseISO, isSameDay } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import Select from "react-select";

const daysOfWeek = [
  "SUNDAY",
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
];
const weekNumbers = [1, 2, 3, 4, 5];

const WorkingPolicy = () => {
  const { user } = useContext(AuthContext);
  const [policy, setPolicy] = useState({
    companyId: user?.accountType === "COMPANY" ? user.id : user?.companyId,
    userId: user?.id ? [user.id] : [],
    workingDays: [],
    dailyWorkingHours: {},
    publicHolidays: [],
    enableWeeklyShiftRotation: false,
    workingWeeksOfMonth: [],
    weeklyRotationalDays: [],
    isCustomForUser: false,
  });
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [activeTab, setActiveTab] = useState("workingDays");
  const [selectedHolidays, setSelectedHolidays] = useState([]);

  const companyId = user?.accountType === "COMPANY" ? user.id : user?.companyId;

  // Fetch users
  useEffect(() => {
    async function fetchUsers() {
      if (!user?.id || !user?.accountType) return;
      const url =
        user?.accountType === "COMPANY"
          ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setUsers(
          data.map((user) => ({
            value: user.id,
            label: `${user.fname} ${user.lname}`,
          }))
        );
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    fetchUsers();
  }, [user]);

  // Fetch policy data
  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        setLoading(true);
        let url;
        if (user?.accountType === "COMPANY") {
          url = `${API_URL}/api/working-policy/${companyId}`;
        } else {
          url = `${API_URL}/api/working-policy/${companyId}/${user?.id}`;
        }

        const response = await axios.get(url, {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        const policyData = response.data;

        // Map the response data to match your state structure
        const mappedData = {
          id: policyData.id,
          companyId: policyData.companyId,
          userId: Array.isArray(policyData.userId)
            ? policyData.userId
            : [policyData.userId],
          workingDays: Object.keys(policyData.dailyWorkingHours || {}), // Extract working days from dailyWorkingHours
          dailyWorkingHours: policyData.dailyWorkingHours || {},
          publicHolidays: policyData.publicHolidays || [],
          enableWeeklyShiftRotation:
            policyData.enableWeeklyShiftRotation || false,
          workingWeeksOfMonth: policyData.workingWeeksOfMonth || [],
          weeklyRotationalDays: policyData.weeklyRotationalDays || [],
          isCustomForUser: policyData.customForUser || false,
        };

        setPolicy(mappedData);
        setSelectedHolidays(
          mappedData.publicHolidays?.map((date) => {
            try {
              return parseISO(date);
            } catch (e) {
              console.error("Invalid date:", date);
              return new Date(); // fallback to current date if parsing fails
            }
          }) || []
        );
        setLoading(false);
      } catch (error) {
        console.error("Error fetching policy:", error);
        setLoading(false);
      }
    };

    fetchPolicy();
  }, [companyId, user]);

  // Handle day selection for working days
  const handleWorkingDayToggle = (day) => {
    setPolicy((prev) => {
      const newWorkingDays = prev.workingDays.includes(day)
        ? prev.workingDays.filter((d) => d !== day)
        : [...prev.workingDays, day];

      // Initialize working hours for newly added days
      const newDailyWorkingHours = { ...prev.dailyWorkingHours };
      if (!prev.workingDays.includes(day)) {
        newDailyWorkingHours[day] = { startTime: "09:00", endTime: "18:00" };
      } else if (!newWorkingDays.includes(day)) {
        delete newDailyWorkingHours[day];
      }

      return {
        ...prev,
        workingDays: newWorkingDays,
        dailyWorkingHours: newDailyWorkingHours,
      };
    });
  };

  // Handle time change for working hours
  const handleTimeChange = (day, field, value) => {
    setPolicy((prev) => ({
      ...prev,
      dailyWorkingHours: {
        ...prev.dailyWorkingHours,
        [day]: {
          ...prev.dailyWorkingHours[day],
          [field]: value,
        },
      },
    }));
  };

  // Handle holiday selection
  const handleHolidaySelect = (date) => {
    if (!date) return; // Guard against undefined/null dates

    setSelectedHolidays((prev) => {
      // Check if the date is already selected
      const isSelected = prev.some((d) => d && isSameDay(d, date));

      if (isSelected) {
        // Remove the date if it's already selected
        return prev.filter((d) => d && !isSameDay(d, date));
      } else {
        // Add the new date if it's not already selected
        return [...prev, date];
      }
    });
  };

  // Handle week number toggle for shift rotation
  const handleWeekNumberToggle = (week) => {
    setPolicy((prev) => ({
      ...prev,
      workingWeeksOfMonth: prev.workingWeeksOfMonth.includes(week)
        ? prev.workingWeeksOfMonth.filter((w) => w !== week)
        : [...prev.workingWeeksOfMonth, week],
    }));
  };

  // Handle rotational day toggle
  const handleRotationalDayToggle = (day) => {
    setPolicy((prev) => ({
      ...prev,
      weeklyRotationalDays: prev.weeklyRotationalDays.includes(day)
        ? prev.weeklyRotationalDays.filter((d) => d !== day)
        : [...prev.weeklyRotationalDays, day],
    }));
  };

  // Handle custom for user toggle
  const handleCustomForUserToggle = (e) => {
    const isChecked = e.target.checked;
    setPolicy((prev) => ({
      ...prev,
      isCustomForUser: isChecked,
      userId: isChecked ? [] : user?.id ? [user.id] : [],
    }));
  };

  const handleUserSelect = (selectedOptions) => {
    const selectedUserId = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setPolicy((prev) => ({
      ...prev,
      userId: Array.isArray(selectedUserId) ? selectedUserId : [],
    }));
  };

  // Save policy
  const savePolicy = async () => {
    try {
      setLoading(true);
      // Create payload without workingDays field
      const { workingDays, ...payloadWithoutWorkingDays } = policy;

      // Prepare the base payload
      const payload = {
        ...payloadWithoutWorkingDays,
        publicHolidays: selectedHolidays.map((date) =>
          format(date, "yyyy-MM-dd")
        ),
      };

      // If it's not custom for user, remove userId from payload
      if (!payload.isCustomForUser) {
        delete payload.userId;
      }

      // Check if we're updating an existing policy (has id)
      const isUpdate = payloadWithoutWorkingDays.id !== undefined;

      // Send the appropriate payload
      const response = await axios.post(
        `${API_URL}/api/working-policy/set`,
        payload,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Update our local state with the response data
      if (response.data?.id) {
        const responseData = response.data;
        setPolicy((prev) => ({
          ...prev,
          id: responseData.id,
          companyId: responseData.companyId,
          userId: Array.isArray(responseData.userId)
            ? responseData.userId
            : [responseData.userId],
          dailyWorkingHours: responseData.dailyWorkingHours || {},
          publicHolidays: responseData.publicHolidays || [],
          enableWeeklyShiftRotation:
            responseData.enableWeeklyShiftRotation || false,
          workingWeeksOfMonth: responseData.workingWeeksOfMonth || [],
          weeklyRotationalDays: responseData.weeklyRotationalDays || [],
          isCustomForUser: responseData.customForUser || false,
        }));
        setSelectedHolidays(
          responseData.publicHolidays?.map((date) => parseISO(date)) || []
        );
      }
      
      toast.success(`Policy ${isUpdate ? "updated" : "saved"} successfully!`);
    } catch (error) {
      const isUpdate = policy.id !== undefined;
      console.error("Error saving policy:", error);
      toast.error(`Failed to ${isUpdate ? "update" : "save"} policy`);
    } finally {
      setLoading(false);
    }
  };

  // Apply to all users
  const applyToAllUsers = async () => {
    if (
      window.confirm("Are you sure you want to apply this policy to all users?")
    ) {
      try {
        setLoading(true);
        // Create payload without workingDays field
        const { workingDays, ...payloadWithoutWorkingDays } = policy;
        const payload = {
          ...payloadWithoutWorkingDays,
          userId: null,
          isCustomForUser: false,
          publicHolidays: selectedHolidays.map((date) =>
            format(date, "yyyy-MM-dd")
          ),
        };

        await axios.post(`${API_URL}/api/working-policy/set`, payload, {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });
        toast.success("Policy applied to all users successfully!");
      } catch (error) {
        console.error("Error applying policy:", error);
        toast.error("Failed to apply policy to all users");
      } finally {
        setLoading(false);
      }
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-[#FAF8FF] dark:bg-gray-900">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-[#673AB7]"></div>
      </div>
    );
  }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); 
        .cfg-heading { font-family: 'Sora', sans-serif; color: #1F2937; } 
        .cfg-font { font-family: 'Inter', sans-serif; }

        /* React Day Picker Custom Styling for Theme */
        .rdp {
          --rdp-cell-size: 40px;
          --rdp-accent-color: #673AB7;
          --rdp-background-color: #F3E8FF;
          margin: 0;
        }
        .dark .rdp {
          --rdp-accent-color: #8B5CF6;
          --rdp-background-color: rgba(139, 92, 246, 0.3);
          color: white;
        }
        .rdp-day_selected, .rdp-day_selected:focus-visible, .rdp-day_selected:hover {
          background-color: var(--rdp-accent-color);
          color: white;
        }
      `}</style>

      <div className="p-4 sm:p-5 bg-[#FAF8FF] cfg-font dark:bg-gray-900 dark:text-gray-100 min-h-screen rounded-lg shadow-lg">
        <div className="max-w-5xl mx-auto">
          <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] overflow-hidden dark:bg-gray-800 dark:border-gray-700">
            
            {/* Header */}
            <div className="bg-[#FAF8FF] dark:bg-gray-800 p-5 sm:p-6 border-b border-[#E5E7EB] dark:border-gray-700">
              <h1 className="text-xl md:text-2xl font-bold cfg-heading dark:text-white">
                {user?.id ? "User Working Policy" : "Company Working Policy"}
              </h1>
              <p className="text-[#6B7280] dark:text-gray-400 mt-1 text-sm font-medium">
                Configure working days, hours, holidays, and shift rotations
              </p>
            </div>

            {/* Custom for user checkbox and user selection (Commented out in original but styled just in case) */}
            {/* <div className="p-5 sm:p-6 border-b border-[#E5E7EB] dark:border-gray-700">
              <div className="flex flex-col space-y-4">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="isCustomForUser"
                    className="h-4 w-4 accent-[#673AB7] rounded"
                    checked={policy.isCustomForUser || false}
                    onChange={handleCustomForUserToggle}
                  />
                  <label
                    htmlFor="isCustomForUser"
                    className="ml-2 text-sm font-semibold text-[#374151] dark:text-white"
                  >
                    Create custom policy for specific users
                  </label>
                </div>

                {policy.isCustomForUser && (
                  <div>
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                      Select Users
                    </label>
                    <Select
                      isMulti
                      options={users}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      value={users.filter((user) =>
                        (policy.userId || []).includes(user.value)
                      )}
                      onChange={handleUserSelect}
                    />
                  </div>
                )}
              </div>
            </div> */}

            {/* Tabs */}
            <div className="border-b border-[#E5E7EB] dark:border-gray-700 bg-white dark:bg-gray-800">
              <nav className="flex overflow-x-auto scrollbar-thin">
                <button
                  className={`px-5 py-3.5 font-semibold text-sm whitespace-nowrap transition-colors ${
                    activeTab === "workingDays"
                      ? "text-[#673AB7] border-b-2 border-[#673AB7] dark:text-[#E9D5FF] dark:border-[#E9D5FF]"
                      : "text-[#6B7280] hover:text-[#374151] dark:text-gray-400 dark:hover:text-gray-200"
                  }`}
                  onClick={() => setActiveTab("workingDays")}
                >
                  Working Days & Hours
                </button>
                <button
                  className={`px-5 py-3.5 font-semibold text-sm whitespace-nowrap transition-colors ${
                    activeTab === "holidays"
                      ? "text-[#673AB7] border-b-2 border-[#673AB7] dark:text-[#E9D5FF] dark:border-[#E9D5FF]"
                      : "text-[#6B7280] hover:text-[#374151] dark:text-gray-400 dark:hover:text-gray-200"
                  }`}
                  onClick={() => setActiveTab("holidays")}
                >
                  Public Holidays
                </button>
                <button
                  className={`px-5 py-3.5 font-semibold text-sm whitespace-nowrap transition-colors ${
                    activeTab === "shiftRotation"
                      ? "text-[#673AB7] border-b-2 border-[#673AB7] dark:text-[#E9D5FF] dark:border-[#E9D5FF]"
                      : "text-[#6B7280] hover:text-[#374151] dark:text-gray-400 dark:hover:text-gray-200"
                  }`}
                  onClick={() => setActiveTab("shiftRotation")}
                >
                  Shift Rotation
                </button>
              </nav>
            </div>

            {/* Tab Content */}
            <div className="p-5 sm:p-6 bg-white dark:bg-gray-800">
              {/* Working Days & Hours Tab */}
              {activeTab === "workingDays" && (
                <div className="space-y-8">
                  <div>
                    <h2 className="text-base font-bold text-[#1F2937] mb-3 cfg-heading dark:text-white border-b border-[#E5E7EB] dark:border-gray-700 pb-2">
                      Working Days
                    </h2>
                    <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-7 gap-3">
                      {daysOfWeek.map((day) => (
                        <button
                          key={day}
                          className={`p-2.5 rounded-md text-center text-sm transition-colors ${
                            (policy.workingDays || []).includes(day)
                              ? "bg-[#F3E8FF] text-[#673AB7] font-bold border border-[#E9D5FF] dark:bg-purple-900/40 dark:border-purple-700 dark:text-purple-300"
                              : "bg-[#F3F4F6] text-[#374151] font-medium border border-[#E5E7EB] hover:bg-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-600"
                          }`}
                          onClick={() => handleWorkingDayToggle(day)}
                        >
                          {day.slice(0, 3)}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div>
                    <h2 className="text-base font-bold text-[#1F2937] mb-4 cfg-heading dark:text-white border-b border-[#E5E7EB] dark:border-gray-700 pb-2">
                      Daily Working Hours
                    </h2>
                    <div className="space-y-4">
                      {(policy.workingDays || []).length === 0 && (
                        <p className="text-sm text-[#6B7280] italic dark:text-gray-400">
                          Please select working days above to set hours.
                        </p>
                      )}
                      {(policy.workingDays || []).map((day) => (
                        <div
                          key={day}
                          className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-6 bg-[#FAF8FF] dark:bg-gray-700/50 p-3 rounded-md border border-[#E5E7EB] dark:border-gray-600"
                        >
                          <div className="font-bold text-sm text-[#374151] dark:text-gray-200 w-24">
                            {day.charAt(0) + day.slice(1).toLowerCase()}
                          </div>
                          <div className="flex items-center gap-3">
                            <input
                              type="time"
                              className="p-2 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                              value={
                                policy.dailyWorkingHours[
                                  day
                                ]?.startTime?.substring(0, 5) || "09:00"
                              }
                              onChange={(e) =>
                                handleTimeChange(day, "startTime", e.target.value)
                              }
                            />
                            <span className="text-[#6B7280] dark:text-gray-400 text-sm font-medium">to</span>
                            <input
                              type="time"
                              className="p-2 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                              value={
                                policy.dailyWorkingHours[day]?.endTime?.substring(
                                  0,
                                  5
                                ) || "18:00"
                              }
                              onChange={(e) =>
                                handleTimeChange(day, "endTime", e.target.value)
                              }
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Holidays Tab */}
              {activeTab === "holidays" && (
                <div className="space-y-6">
                  <div>
                    <h2 className="text-base font-bold text-[#1F2937] mb-4 cfg-heading dark:text-white border-b border-[#E5E7EB] dark:border-gray-700 pb-2">
                      Public Holidays
                    </h2>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                      <div className="bg-[#FAF8FF] dark:bg-gray-700/50 p-4 rounded-xl border border-[#E5E7EB] dark:border-gray-600 flex justify-center">
                        <DayPicker
                          mode="multiple"
                          selected={selectedHolidays}
                          onSelect={setSelectedHolidays}
                          modifiers={{
                            selected: selectedHolidays,
                          }}
                          modifiersStyles={{
                            selected: {
                              backgroundColor: "#673AB7",
                              color: "white",
                              borderRadius: "6px"
                            },
                          }}
                        />
                      </div>
                      
                      <div className="bg-[#FAF8FF] dark:bg-gray-700/50 p-4 rounded-xl border border-[#E5E7EB] dark:border-gray-600 h-full max-h-[400px] flex flex-col">
                        <h3 className="text-sm font-bold text-[#1F2937] mb-3 dark:text-white">
                          Selected Holidays ({selectedHolidays.length})
                        </h3>
                        <div className="overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600 flex-1">
                          {selectedHolidays.length > 0 ? (
                            <ul className="space-y-2">
                              {selectedHolidays.map((date, index) => {
                                try {
                                  return (
                                    <li
                                      key={index}
                                      className="p-2.5 flex justify-between items-center bg-white dark:bg-gray-800 border border-[#E5E7EB] dark:border-gray-600 rounded-md shadow-sm"
                                    >
                                      <span className="text-sm font-medium text-[#374151] dark:text-gray-200">
                                        {date
                                          ? format(date, "MMMM d, yyyy")
                                          : "Invalid date"}
                                      </span>
                                      <button
                                        className="text-[#EF4444] hover:text-[#B91C1C] text-xs font-semibold px-2 py-1 bg-[#FEF2F2] hover:bg-red-100 dark:bg-red-900/30 dark:hover:bg-red-900/50 rounded transition-colors"
                                        onClick={() => handleHolidaySelect(date)}
                                      >
                                        Remove
                                      </button>
                                    </li>
                                  );
                                } catch (e) {
                                  console.error("Error formatting date:", date, e);
                                  return null;
                                }
                              })}
                            </ul>
                          ) : (
                            <div className="flex items-center justify-center h-full min-h-[150px]">
                              <p className="text-[#6B7280] italic text-sm dark:text-gray-400">
                                No holidays selected
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Shift Rotation Tab */}
              {activeTab === "shiftRotation" && (
                <div className="space-y-6">
                  <div className="flex items-center bg-[#FAF8FF] dark:bg-gray-700/50 p-4 rounded-lg border border-[#E5E7EB] dark:border-gray-600">
                    <input
                      type="checkbox"
                      id="enableShiftRotation"
                      className="h-4 w-4 accent-[#673AB7] rounded cursor-pointer"
                      checked={policy.enableWeeklyShiftRotation || false}
                      onChange={(e) =>
                        setPolicy((prev) => ({
                          ...prev,
                          enableWeeklyShiftRotation: e.target.checked,
                        }))
                      }
                    />
                    <label
                      htmlFor="enableShiftRotation"
                      className="ml-3 font-bold text-sm text-[#1F2937] dark:text-white cursor-pointer"
                    >
                      Enable Weekly Shift Rotation
                    </label>
                  </div>

                  {policy.enableWeeklyShiftRotation && (
                    <div className="space-y-6 pl-1 sm:pl-2 border-l-2 border-[#E9D5FF] dark:border-purple-900/50 ml-2">
                      <div>
                        <h2 className="text-base font-bold text-[#1F2937] mb-3 cfg-heading dark:text-white">
                          Working Weeks of Month
                        </h2>
                        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 pl-4">
                          {weekNumbers.map((week) => (
                            <button
                              key={week}
                              className={`p-2.5 rounded-md text-center text-sm transition-colors ${
                                (policy.workingWeeksOfMonth || []).includes(week)
                                  ? "bg-[#F3E8FF] text-[#673AB7] font-bold border border-[#E9D5FF] dark:bg-purple-900/40 dark:border-purple-700 dark:text-purple-300"
                                  : "bg-[#F3F4F6] text-[#374151] font-medium border border-[#E5E7EB] hover:bg-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-600"
                              }`}
                              onClick={() => handleWeekNumberToggle(week)}
                            >
                              Week {week}
                            </button>
                          ))}
                        </div>
                      </div>

                      <div>
                        <h2 className="text-base font-bold text-[#1F2937] mb-3 cfg-heading dark:text-white">
                          Weekly Rotational Days
                        </h2>
                        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-7 gap-3 pl-4">
                          {daysOfWeek.map((day) => (
                            <button
                              key={day}
                              className={`p-2.5 rounded-md text-center text-sm transition-colors ${
                                (policy.weeklyRotationalDays || []).includes(day)
                                  ? "bg-[#F3E8FF] text-[#673AB7] font-bold border border-[#E9D5FF] dark:bg-purple-900/40 dark:border-purple-700 dark:text-purple-300"
                                  : "bg-[#F3F4F6] text-[#374151] font-medium border border-[#E5E7EB] hover:bg-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-600"
                              }`}
                              onClick={() => handleRotationalDayToggle(day)}
                            >
                              {day.slice(0, 3)}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Footer with action buttons */}
            <div className="bg-[#FAF8FF] px-5 sm:px-6 py-4 flex flex-col sm:flex-row justify-end gap-3 dark:bg-gray-800 border-t border-[#E5E7EB] dark:border-gray-700 rounded-b-xl">
              {!user && (
                <button
                  className="px-5 py-2.5 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                  onClick={applyToAllUsers}
                  disabled={loading}
                >
                  Apply to All Users
                </button>
              )}
              <button
                className={`px-6 py-2.5 rounded-md font-semibold text-sm shadow-md transition-colors ${
                  loading
                    ? "bg-[#9CA3AF] text-white cursor-not-allowed shadow-none"
                    : "bg-[#673AB7] text-white hover:bg-[#5E35A6]"
                }`}
                onClick={savePolicy}
                disabled={loading}
              >
                {loading
                  ? "Saving..."
                  : policy.id
                  ? "Update Policy"
                  : "Save Policy"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkingPolicy;
